<router-outlet />

<zero-waste-loader />
<app-environment-info />
